module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"param":{"numberToKeep":"Maximum number of topics to keep","scalingFactor":"Scaling the distribution for the query","normalizeMaxScore":"Normalize so the score of the top topic is 1.0"}}}')
  delete Component.options._Ctor
}
